import { render } from "./HealthTracking.vue?vue&type=template&id=dd6c8c9c&scoped=true"
import script from "./HealthTracking.vue?vue&type=script&lang=js"
export * from "./HealthTracking.vue?vue&type=script&lang=js"

import "./HealthTracking.vue?vue&type=style&index=0&id=dd6c8c9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6c8c9c"]])

export default __exports__